import { cn } from "@omni/utils/styles";

import { CategoryButton } from "@/components/General/Sidebar/components/assortiment/components/categoryButton";
import { CategoryAnchor } from "@/components/General/Sidebar/components/assortiment/components/categoryLink";
import { useSubCategory } from "@/components/General/Sidebar/context/sidebar.context";

type Props = {
    className?: string;
};

export const Link = ({ className }: Props) => {
    const { subCategory } = useSubCategory();

    if (!subCategory) return null;

    const hasSubCategories = !!subCategory.subCategories?.length;

    if (hasSubCategories) {
        return (
            <CategoryButton
                category={subCategory}
                className={cn(className)}
            />
        );
    } else {
        return (
            <CategoryAnchor
                category={subCategory}
                className={cn(className)}
            />
        );
    }
};
